<template>
  <div class="home">
    <div class="lang_toggle">
      <span :class="btnLangClass('pt')" @click="onPtPress">PT
      </span> | <span :class="btnLangClass('en')" @click="onEnPress">EN</span>
    </div>
    <p class="content__text" v-html="contentText"></p>
    <br><br><br><br><br>
    <p class="content__text content__footer_note" v-html="footerNote"></p>
  </div>
</template>

<script>
export default {
  name: 'Bubuia',
  components: {
  },
  data() {
    return {
      selectedLang: null, // 'en' or 'pt'
      footer: {
        en: `1. Steve Paxton concluded the conference he gave in Lisbon in 2019, at Culturgest.
      <br>
      2. Theia, the planet that is believed to have collided with Earth, forming the Moon and bringing large amounts of water to our planet: <a href="https://ciencias.ulisboa.pt/en/node/17568"
        target="_blank">https://ciencias.ulisboa.pt/en/node/17568</a>`,
        pt: `1. Steve Paxton fechava assim a conferência que deu em Lisboa, no ano de
      2019, na Culturgest.
      <br>
      2. Theia, o planeta que terá colidido com a Terra, formado a lua e trazido grandes quantidades de água para o
      nosso planeta: <a href="https://ciencias.ulisboa.pt/en/node/17568"
        target="_blank">https://ciencias.ulisboa.pt/en/node/17568</a>`
      },
      messages: {
        en: `While Falling, Floating.
      <br><br>
      Every day, patiently, in a corner of the great estuary, right there where the river meets the sea, with the deep
      inner silence required to find the point of harmony that allows the axes of gravity of each stone to connect,
      there are those, unseen, charged with re-establishing the balance of the world. They persist until the very last
      moment of the rising tide, when everything already seems swept away by the waters. Looking at them, these patient
      ones who lift the figures of the world, at the dirt and age of their clothes, one could easily mistake them for
      simple indigents, poor souls fallen out of life, cast away from the dazzling lights—the ones that marvel and
      blind. They may perhaps be homeless, we do not know. Certainly, without a place. Yet they are fundamental
      presences so that the world’s existence may persist. Tomorrow, when the breath of the river once again pulls the
      waters back from the lands that shape its banks, they will surely return to help recreate the world. Not the same
      one, but another, that will fall again with the next tide, like the unstable balance of João Mouro’s sculptures.
      It is a daily game, a fleeting between balance and inevitable fall, like one who plays knowing that life is a
      serious matter.
      <br><br>
      “Despair not. (…) we modestly say we have only begun to understand. We may have not even begun yet (…) There’s
      lots of chaos, and evolution, that we have yet to find…”<sup>1</sup> once said a master—in the Eastern sense of
      the word—of the study of the fluidity of falling and of the relationship with gravity. In his work, the surface of
      the floor was a dance partner and support for massive fluidity. To follow, to surrender to that force and to the
      bodies that offered it ground, to investigate that matter, the mutation of spatial qualities into gravitational
      mass, into bodies that yield to flows and counter-flows, to smooth or jagged movements, with varied rhythms and
      abrupt changes of the river of that force that courses through us and compels us to stay, to fall, to dive, to
      move, to follow the current of bodies, rising simultaneously against the flow, as sings Céu—the author of the song
      that gave title to this exhibition, and that has been the soundtrack of a journey and a conversation that has
      lasted for so many years. Céu sings still, even before reaching the estuary: “o destino é o mar onde vou-me
      desfazer” [“destiny is the sea where I shall dissolve”].
      <br><br>
      Alive, we are not bodies of stone. We breathe, and so we can rehearse going beyond the ground, not obeying just
      the contingencies and limits of chance falls provoked by the forces of the tides. Not resisting them but entering
      even further into gravity and exploring the fall in an aquatic world where our entire organism, bent on survival,
      compels us to rise back up. But life is tension and polarity, so let us rehearse exploring the opposing forces
      present in the same gesture: to manage to float, in the direction of depth. To inhabit that medium until we no
      longer need to breathe, until we can feel again, even if only temporarily, our biological ancestry: that we are
      aquatic (the space where we most easily experience something akin to flight) and not only terrestrial. Children of
      Theia<sup>2</sup>, not only of Earth. To dwell there, until we remember, we must return and breathe once more. To
      come out of that elsewhere that enveloped us and to which we prepare, time and again, to return. To understand the
      massive oceanic movements of the body—their directions, pressures, temperatures—the inverted world below, where
      flight is descent, opposite to the solar reverberations on the surface crossed above. This exploration of falling
      and ascending is the inaugural movement of Guillaume Vieira’s underwater images.
      <br><br>
      To dive or to ascend, chaos or evolution. What is above mirroring what is below. Mountains—which, we know, are
      waves slowed into stillness—becoming analogous to valleys. Rounded shapes of stones and moss, or jagged, hard
      rock, layered, touched by an extreme light, scorched. Portals and underwater flames, organic bodies seen in stone,
      refractions of light sliding, bodies doubling themselves, whose materiality and gravity enter suspension and
      transformation.
      <br><br>
      The pressure borne by the photographic camera, and by the film itself, is the same borne by the body that makes
      these images, pressed by its entry into this aquatic medium of oceanic currents. This entry of the body—not yet
      dissolved! —into the oceanic realm allows us to see surfaces from their reverse, bodies that fall as much as they
      float or fly, traversed by transmissions of light. Yves Klein once said that the conquest of space would not be
      achieved with spaceships, but by luminous impregnation—and so he created his blue.
      <br><br><br>
      Liliana Coutinho
      <br>
      September 1, 2025`,
        pt: `Ao cair, flutuar.
      <br><br>
      Todos os dias, pacientemente, num canto do grande estuário, ali mesmo onde o rio encontra o mar, com o grande
      silêncio interior que é necessário para encontrar o ponto de harmonia que permite ligar os eixos de gravidade cada
      pedra, há quem, invisível, se encarregue de restabelecer o equilíbrio das coisas do mundo, persistindo até ao
      último momento da subida das marés, quando tudo já se vê a ser levado pelas águas. Olhando para eles, esses
      pacientes que erguem as figuras do mundo, para a sujidade e velhice das suas roupas, facilmente seriam confundidos
      com simples indigentes, com os pobres diabos caídos da vida, fora das luzes da ribalta - as que maravilham e
      cegam. Serão talvez sem teto, não sabemos. Certamente, sem lugar. São, no entanto, presenças fundamentais para que
      a existência do mundo persista. Num amanhã, ou quando o movimento da respiração do rio voltar a afastar as águas
      das terras que formam as suas margens, eles voltarão certamente para ajudar a recriar o mundo. Não o mesmo, mas um
      outro, que voltará a cair numa das próximas marés. Como o equilíbrio instável das esculturas de João Mouro, é uma
      brincadeira diária, um balanço entre o equilíbrio e a inevitável queda, assim como quem brinca porque sabe que a
      vida é um caso sério.
      <br><br>
      “Despair not. (…) we modestly say we have only begun to understand. We may have not even begun yet (…) There’s
      lots of chaos, and evolution, that we have yet to find…”<sup>1</sup>
      [Não desesperem. (...) Modestamente, dizemos
      que apenas
      começámos a compreender. Talvez ainda nem tenhamos começado (...) Há muito caos e evolução que ainda temos de
      descobrir...] disse uma vez um mestre – na aceção oriental do termo - do estudo da fluidez da queda e da relação
      com a gravidade. No seu trabalho, a superfície do chão era parceira de dança e suporte da fluidez massiva. Seguir,
      entregar-se a essa força e aos corpos que lhe ofereciam chão, investigar essa matéria, a mutação das qualidades do
      espaço numa massa gravitacional, em corpos que se entregam aos fluxos e contra fluxos, aos movimentos lisos ou
      picados com ritmos variados, mudanças abruptas, do rio dessa força que nos atravessa e impele a ficar, a cair, a
      mergulhar, a mover, a seguir a corrente dos corpos, subindo simultaneamente em contra fluxo, como canta Céu - a
      autora da canção que deu o título a esta exposição e que tem sido banda sonora de uma viagem e de uma conversa que
      já dura há tantos anos. Canta ainda Céu, ainda antes de chegar ao estuário: “o destino é o mar onde vou-me
      desfazer”.
      <br><br>
      Vivos, não somos corpo de pedra. Respiramos, por isso podemos ensaiar ir para além do chão, não obedecer só às
      contingências e aos limites do acaso das quedas provocadas pelas forças das marés. Não lhes resistir, mas entrar
      ainda mais na gravidade e explorar a queda num mundo aquático onde todo o nosso organismo, querendo insistir no
      estado de sobrevivência, nos impele a voltar a subir. Mas vida é tensão, polaridade, e por isso ensaiemos explorar
      as forças contrárias presentes num mesmo gesto: conseguir flutuar, em direção à profundidade. Habitar esse meio
      até não precisarmos mais de respirar, até voltar a sentir, mesmo que só temporariamente, a nossa ancestralidade
      biológica: que somos aquáticos (o espaço onde mais facilmente podemos experimentar algo análogo à experiência do
      voo) e não só terrestres. Filhos de Theia<sup>2</sup> e não só da Terra. Habitar ali, até lembrar que é preciso
      voltar e
      respirar outra vez. Sair desse fora que nos envolveu e ao qual nos preparamos, uma e outra vez, a voltar.
      Compreender os movimentos massivos oceânicos com o corpo, as suas direções, pressões, temperaturas, o mundo
      inverso lá em baixo onde o voo é descida, no sentido oposto ao das reverberações solares na superfície que se
      atravessou. Esta exploração da queda e da ascensão é o movimento inaugural das imagens subaquáticas de Guillaume
      Vieira.
      <br><br>
      Mergulhar ou ascender, caos ou evolução… o que está em cima ser igual ao que está em baixo, as montanhas – que,
      sabemos, são ondas em estado de lentidão - serem análogas aos vales. Formas redondas de pedras e limos, ou rocha
      escarpada e dura, lamelada, tocada por uma luz extrema, queimada. Portais e chamas subaquáticas, corpos orgânicos
      vistos em pedras, refrações de luz a escorregar, corpos que se duplicam, cuja materialidade e gravidade entram em
      suspensão e transformação.
      <br><br>
      A pressão a que é sujeita a máquina fotográfica, e a pelicula fotográfica, é a mesma a que é sujeita o corpo de
      quem faz estas imagens, pressionado pela entrada nesse espaço aquático, de correntes oceânicas. Esta entrada do
      corpo - não desfeito ainda! - no meio oceânico deixa-nos ver as superfícies a partir do seu avesso, corpos que
      tanto caem como flutuam ou voam, atravessados por transmissões de luz. Dizia o pintor Yves Klein, que a conquista
      do espaço não se fará com naves espaciais, mas por impregnação luminosa – e por isso criou o seu azul.
      <br><br><br>
      Liliana Coutinho
      <br>
      1 de setembro 2025`
      }
    };
  },
  created() {
    const locale = navigator.language || navigator.userLanguage;
    if (locale) {
      const lang = locale.split("-")[0]; // e.g. "en" or "pt"
      this.selectedLang = lang === 'pt' ? 'pt' : 'en';
    } else {
      this.selectedLang = 'en';
    }
  },
  computed: {
    contentText() {
      if (!this.selectedLang) return this.messages.en;
      return this.messages[this.selectedLang] || this.messages.en;
    },
    footerNote() {
      if (!this.selectedLang) return this.footer.en;
      return this.footer[this.selectedLang] || this.footer.en;
    }
  },
  methods: {
    btnLangClass(lang) {
      return {
        'lang_toggle__link': true,
        'lang_toggle__link--active': this.selectedLang === lang
      };
    },
    onEnPress() {
      this.selectedLang = "en";
    },
    onPtPress() {
      this.selectedLang = "pt";
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep sup {
  font-size: 14px;
  font-weight: 600;
  vertical-align: super;
  // color: $theme-color-primary;
}

.home {
  width: 100%;
  padding-left: $content-padding;
  padding-right: $content-padding;
  padding-bottom: $content-padding;
  max-width: 700px;
}

.content {
  &__title {
    font-family: $base-font-family;
    font-size: 1.75rem !important;
    line-height: 1.4 !important;
    margin-top: 0px;
    margin-bottom: 60px;
    color: $theme-color-primary;
  }

  &__text {
    font-family: $base-font-family;
    font-size: 1rem !important;
    line-height: 1.5 !important;
    margin-top: 10px;
    text-align: left; //justify;
  }

  &__footer_note {
    font-size: 0.8rem !important;
    line-height: 1.3 !important;
    text-align: left;
    border-top: 1px solid #cccccc;
    padding-top: $content-padding;
  }
}

.lang_toggle {
  display: flex;
  margin-bottom: 2 * $content-padding;
  color: #cccccc;
  align-items: center;
  justify-content: center;

  &__link {
    font-family: $base-font-family;
    font-size: 0.88rem !important;
    color: #cccccc;
    cursor: pointer;
    text-decoration: none;
    padding: 8px 6px;

    &:hover {
      text-decoration: underline;
      // color: $theme-color-primary;
      // color: darken($theme-color-primary, 10%);
    }

    &--active {
      // font-weight: 600;
      color: #666666;
      cursor: default;

      &:hover {
        text-decoration: none;
        // color: $theme-color-primary;
        // color: darken($theme-color-primary, 10%);
      }
    }
  }
}
</style>
